import Vue from 'vue'
import Router from 'vue-router'
import HelloWorld from '@/components/HelloWorld'
import home from '@/pages/home'
import login from '@/pages/login/login'
import register from '@/pages/login/register'
import product from '@/pages/product/product'
import homes from '@/pages/homes/homes'
import about from '@/pages/about/about'
import contact from '@/pages/about/contact'
import event from '@/pages/about/event'

import detaile from '@/pages/product/detaile'
import jobs from '@/pages/jobs/jobs'
import post from '@/pages/jobs/post'
import seach from '@/pages/tools/seach'
import dealer from '@/pages/dealer/dealer'
import partner from '@/pages/dealer/partner'
import investment from '@/pages/dealer/investment'
import news from '@/pages/news/news'

import article from '@/pages/news/article'
import test from '@/pages/test/test'

import cor_governance from '@/pages/about/cor_governance'
import sw_notice from '@/pages/about/sw_notice'
import join_us from '@/pages/about/join_us'
import newInfo from '@/pages/news/newInfo'

import gszl from '@/pages/dealer/gszl'
import file from '@/pages/dealer/file'

import toolteach from '@/pages/product/toolteach'

import sa_article from '@/pages/product/sa_article'
import sa_show from '@/pages/product/sa_show'
import sa_type from '@/pages/product/sa_type'
import sa_sour from '@/pages/product/sa_sour'

import qu_money from '@/pages/qu/money'
import qu_excel from '@/pages/qu/excel'
import qu_year from '@/pages/qu/year'

import corporateculture from '@/pages/about/corporateculture'

Vue.use(Router)

let router = new Router({
  mode: 'history',
  routes: [
    {
      path: '/',               //映射路径
      redirect: '/home',       //默认重定向
    },
    {
      path: '/home',
      redirect: '/homes',     //默认重定向
    },

    {
      name: '管理',           //看起来用处不大，参考https://blog.csdn.net/Gimamy/article/details/87883507
      path: '/home',          //映射路径
      component: home,        //映射组件
      children: [             //利用children属性实现子路由，数据显示在父文件里，具体参考D:\node\css2\sino-wealth\src\pages\home.vue
        {
          name: "首页",
          path: "/homes",
          component: homes,
        },
        {
          name: '注册',
          path: '/register',
          component: register,
        },
        {
          name: '登录',
          path: '/login',
          component: login,
        },
        {
          name: "产品",
          path: "/product",
          component: product,
        },
        {
          name: "关于中颖",
          path: "/about",
          component: about,
        },
        {
          name: "联系我们",
          path: "/contact_us",
          component: contact,
        },
        {
          name: "中颖大记事",
          path: "/sw_ev",
          component: event,
        },
        {
          name: "产品详情",
          path: "/detaile",
          component: detaile,
        },
        {
          name: "招聘",
          path: "/jobs",
          component: jobs,
        },
        {
          name: "招聘详情",
          path: "/post",
          component: post,
        },
        {
          name: "工具与资料",
          path: "/seach",
          component: seach
,
        },
        {
          name: "经销商",
          path: "/dealer",
          component: dealer,
        },
        {
          name: "合作伙伴",
          path: "/partner",
          component: partner,
        },
        {
          name: "投资者关系",
          path: "/investment",
          component: investment,
        },
        {
          name: "信息更新",
          path: "/news",
          component: news,
        },
        {
          name: "技术文章",
          path: "/article",
          component: article,
        },
        {
          name: "测试页面",
          path: "/test",
          component: test,
        },
        {
          name: "公司治理",
          path: "/gszl",
          component: gszl,
        },
        {
          name: "诚信建设活动",
          path: "/file",
          component: file,
        },
        {
          name: "工具视频教学",
          path: "/toolteach",
          component: toolteach,
        },
        {
          name: "信息更新详情",
          path: "/newInfo",
          component: newInfo,
        },
        {
          name: "公司治理",
          path: "/cor_governance",
          component: cor_governance,
        },
        {
          name: "企业文化",
          path: "/corporateculture",
          component: corporateculture,
        },
        {
          name: "矿产冲突声明",
          path: "/sw_notice",
          component: sw_notice,
        },
        {
          name: "加入我们",
          path: "/join_us",
          component: join_us,
        },
        {
          name: "对外文章目录",
          path: "/sa_article",
          component: sa_article,
        },
        {
          name: "对外文章",
          path: "/sa_show",
          component: sa_show,
        },
        {
          name: "对外文章",
          path: "/sa_type",
          component: sa_type,
        },
        {
          name: "对外文章搜索",
          path: "/sa_sour",
          component: sa_sour,
        },
        {
          name: "季度营业额",
          path: "/qu_money",
          component: qu_money,
        },
        {
          name: "季度报表",
          path: "/qu_excel",
          component: qu_excel,
        },
        {
          name: "年度报告",
          path: "/qu_year",
          component: qu_year,
        },
      ]
    },
  ]
})

export default router



// WEBPACK FOOTER //
// ./src/router/index.js